// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"0359eb3e","189":"b54fc025","200":"6b80827b","271":"6f2efc9a","283":"3c7d35ad","353":"e992d0d2","381":"eb7d3743","396":"a1ed283d","499":"2d8dd746","663":"e291da90","744":"786174b7","760":"0427190c","830":"1cb1ef46","892":"fe7f2c34","904":"6f3e8149"}[chunkId] + ".chunk.js";
};